import type { ReactNode } from 'react'
import useRightPanelState from './useRightPanelState'
import { RightPanelContext, RightPanelNotificationsContext } from './rightPanelContext'

interface RightPanelProviderProps {
  children: ReactNode
}

const RightPanelProvider = ({ children }: RightPanelProviderProps) => {
  const { panel, notifications } = useRightPanelState()

  return (
    <RightPanelContext.Provider value={panel}>
      <RightPanelNotificationsContext.Provider value={notifications}>
        {children}
      </RightPanelNotificationsContext.Provider>
    </RightPanelContext.Provider>
  )
}

export default RightPanelProvider
